import "./InfoHeaderBar.scss";
import { useTranslation } from "react-i18next";
import React from "react";

interface IProps {
    title?: string;
    description?: string;
    icon?: string;
}
function InfoHeaderBar(props: IProps) {
    const { t } = useTranslation();
    return (
        <div className="infoHeaderBar">
            {props.icon && <img alt="alt" src={props.icon} className="headerImage" />}
            <div className="headerText">
                <div className="title">{props.title}</div>

                <div className="description">{props.description}</div>
            </div>
        </div>
    );
}

export default InfoHeaderBar;
